<script setup>
import FordButton from '@/components/FordButton.vue';
import EventSection from './EventSection.vue';

defineProps({
  event: Object,
});

const emit = defineEmits(['close']);

const closeModal = () => emit('close');
</script>
<template>
  <div class="tablet:text-center bg-ford-gray-light">
    <h1
      class="
        text-[1.125rem]
        tablet:text-[2.125rem]
        font-FordAntennaMed
        mb-[1.875rem]
        max-w-[53rem]
        mx-auto
      "
    >
      Your Appointment Has Been Canceled
    </h1>
    <p
      class="
        text-[.875rem]
        tablet:text-[1rem]
        text-ford-gray-darker
        mb-[1.875rem]
        max-w-[48rem]
        mx-auto
      "
    >
      Your appointment with Ford Pro™ at
      <span v-html="event.name" class="[&_*]:inline"></span> has been
      successfully canceled. Thank you for your interest.
    </p>

    <ford-button
      class="mb-[3rem]"
      :prevent-default="false"
      transparent
      @method="closeModal"
      >Close</ford-button
    >
    <hr class="mx-auto max-w-[50rem] mb-[2.5rem] border-[#969696]" />
    <event-section :event="event" />
  </div>
</template>
